module.exports = __webpack_public_path__ + "img/2.58db8d02.png";